export function getInitials(firstName, lastName) {
  const firstNameLetter = (firstName && firstName.charAt(0).toUpperCase()) || '';
  const lastNameLetter = (lastName && lastName.charAt(0).toUpperCase()) || '';
  return `${firstNameLetter}${lastNameLetter}`;
}

export function getFullName(firstName, lastName, middleName) {
  if (firstName && lastName) {
    return firstName + (middleName ? ` ${middleName}` : '') + ` ${lastName}`;
  }
  return '';
}

export function getPossessiveFirstName(firstName, locale) {
  if (locale === 'en-US') {
    return firstName && firstName.slice(-1) === 's' ? `${firstName}'` : `${firstName}'s`;
  }
  return firstName;
}

export const validateNameFormat = (name) => {
  if (typeof name !== 'string') {
    return false;
  }

  const regEx = /^(['.\-a-zA-Z ÀàÁáÂâÇçÈÉÊèéêÔô]{0,50})$/;
  return regEx.test(name);
};

export const validateNameLength = (name, maxLength = 20) => {
  return name.length <= maxLength;
};

export const validateMiddleNameLength = (name, maxLength = 15) => {
  return name.length <= maxLength;
};

export const trimSpaces = (name) => {
  const regexPattern = /\s+/g;
  return name && name.replace(regexPattern, ' ').trim();
};

export function getStrippedName(name) {
  if (typeof name !== 'string') return name;
  let nameStripped = name.replace(' ', '').replace("'", '').replace('-', '').replace('_', '').replace('.', '');
  nameStripped = nameStripped
    .replace(/À/g, 'A')
    .replace(/Á/g, 'A')
    .replace(/Â/g, 'A')
    .replace(/Ã/g, 'A')
    .replace(/Ä/g, 'A')
    .replace(/Å/g, 'A')
    .replace(/Æ/g, 'A');
  nameStripped = nameStripped
    .replace(/à/g, 'a')
    .replace(/á/g, 'a')
    .replace(/â/g, 'a')
    .replace(/ã/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/å/g, 'a')
    .replace(/æ/g, 'a');
  nameStripped = nameStripped.replace(/Ç/g, 'c').replace(/ç/g, 'c');
  nameStripped = nameStripped.replace(/Ð/g, 'D').replace(/ð/g, 'd');
  nameStripped = nameStripped.replace(/È/g, 'E').replace(/É/g, 'E').replace(/Ê/g, 'E').replace(/Ë/g, 'E');
  nameStripped = nameStripped.replace(/è/g, 'e').replace(/é/g, 'e').replace(/ê/g, 'e').replace(/ë/g, 'e');
  nameStripped = nameStripped.replace(/Ì/g, 'I').replace(/Í/g, 'I').replace(/Î/g, 'I').replace(/Ï/g, 'I');
  nameStripped = nameStripped.replace(/ì/g, 'i').replace(/í/g, 'i').replace(/î/g, 'i').replace(/ï/g, 'i');
  nameStripped = nameStripped.replace(/Ñ/g, 'N').replace(/ñ/g, 'n');
  nameStripped = nameStripped
    .replace(/Ò/g, 'O')
    .replace(/Ó/g, 'O')
    .replace(/Ô/g, 'O')
    .replace(/Õ/g, 'O')
    .replace(/Ö/g, 'O')
    .replace(/Ø/g, 'O');
  nameStripped = nameStripped
    .replace(/ò/g, 'o')
    .replace(/ó/g, 'o')
    .replace(/ô/g, 'o')
    .replace(/õ/g, 'o')
    .replace(/ö/g, 'o')
    .replace(/ø/g, 'o');
  nameStripped = nameStripped.replace(/Ù/g, 'U').replace(/Ú/g, 'U').replace(/Û/g, 'U').replace(/Ü/g, 'U');
  nameStripped = nameStripped.replace(/ÿ/g, 'y').replace(/þ/g, 'y').replace(/ý/g, 'y').replace(/Ý/g, 'Y');

  return nameStripped;
}
